import escape from 'lodash.escape';
import randomGenerator from '../modules/random-generator';
import passwordVisibility from '../modules/password-visibility';

const initialize = () => {
    randomGenerator();
    passwordVisibility();

    const contactDeleteModal = document.getElementById('contactDeleteModal');
    if (!contactDeleteModal) {
        return;
    }

    contactDeleteModal.addEventListener('show.bs.modal', (event) => {
        const button = event.relatedTarget;
        const contact = button.getAttribute('data-contact');
        const action = button.getAttribute('data-action');

        contactDeleteModal.querySelector('#contactDeleteForm').setAttribute('action', action);
        contactDeleteModal.querySelector('#contactTypeNameSpan').innerHTML = escape(contact);
    });
};

export default initialize;
